import {React, useState, useEffect} from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Helper} from "../../tools/Helper";
import {api_Routes} from "../../api_Routes";
import MainLoader from "../common/main-loader";
import Slider from "./Slider";
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";

const LastMinute = () => {
    const navigate = useNavigate();
    const [lastMinutes, setLastMinutes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        get_services();
    }, []);

    const get_services = async () => {
        setIsLoading(true);
        const {response, message} = await Helper.Get({
            url: api_Routes.LastMinute.view,
            hasToken: true,
            data: {results: 100},
        });
        if (response) {
            setLastMinutes(response.data)
        } else {
        }
        setIsLoading(false);
    };

// console.log(lastMinutes.length)


    return isLoading ? (
        <MainLoader isFull={true}/>
    ) : (
        <>
            <Box sx={{padding: {xs: "30px", md: "30px 80px"}}}>
                <Box sx={{marginTop: "20px"}}>
                    <Typography
                        sx={{
                            fontSize: "40px",
                            lineHeight: "45px",
                            fontWeight: "700",
                            color: "#474747",
                            textAlign: "center",
                        }}
                    >
                        Discover our exclusive Last Minute Page and Find the best offers
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "18px",
                            lineHeight: "20px",
                            fontWeight: "400",
                            color: "#474747",
                            textAlign: "center",
                            marginTop: "30px",
                        }}
                    >
                        Browse all Last minute offers and choose the best one that suits you!
                    </Typography>
                    <Box
                        sx={{
                            textAlign: 'center',
                            marginTop: "30px",
                        }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#3F78E0",
                                color: "#F1F5FD",
                                borderRadius: "20px",
                                padding: "8px 20px",
                                "&:hover": {backgroundColor: "#355dab"},
                                textTransform: "capitalize",
                                fontWeight: 600,
                            }}
                            onClick={() => navigate("/post-last-minute")}
                        >
                            Add Your Last Minute
                        </Button>
                    </Box>

                </Box>
                {
                    lastMinutes.map((lastMinute, index) => (
                        <Slider sliders={[lastMinute]}/>
                    ))
                }

            </Box>
        </>
    );
};
export default LastMinute;
